// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"535":"login","826":"index"}[chunkId] + "." + {"535":"546b984c","826":"26c62cdf"}[chunkId] + ".css";
};